<template>
  <div class="col-12">
    <div class="row mt-4">
      <div class="col-2"></div>
      <div class="col-8">
        <p></p>
      </div>
      <div class="col-2"></div>

    </div>
  </div>

</template>

<script>

export default {
  components: {}
}
</script>

<style scoped>

</style>